import React from "react";
import { Button } from "reactstrap";
import "./product-page.scss";
import InnerShadowButton from "../../../components/common/buttons/innerShadow";
import HowToClaim from "../../../components/common/HowToClaim";
import LifeExamples from "../../../components/common/LifeExamples";
import CoveredItem from "../../../components/common/rows/coveredItem";
import NotCoveredItem from "../../../components/common/rows/notCoveredItem";
// import Footer from "../../../components/common/footer";

class ProductNewDesign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "covered",
      buyRibbonShow: false,
      fullTabBar: false,
      device: "mobile",
      selectedPlan: props.match.params["plan"],
      selectedSection: "life",
      calculatePremiumLink:
        "http://life.toffeeinsurance.com/#/life/vanilla/calculate_premium",
    };
    if (!["single", "family"].includes(props.match.params["plan"])) {
      props.history.push("/");
    }
  }

  cards = {
    life: {
      covered: [
        {
          title: "Life Cover for ₹50 Lakhs",
          subTitle:
            "A term life insurance that pays your nominee ₹50 Lakhs on death or diagnosis of terminal illness.",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "24px 0 0 24px",
          borderMobile: "18px 18px 0 0",
        },
        {
          title: "Renewal upto 75 Years",
          subTitle: "You can renew this insurance until the age of 75 years.",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 24px 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Waiver of Premium on permanent disability",
          subTitle:
            "In case of an accident/illness causing permanent disability, all your future premiums are waived until you are 75 years of age. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 24px 24px 0",
          borderMobile: "0 0 18px 18px",
        },
      ],
      notCovered: [
        {
          title: "Suicide within 1 year ",
          subTitle:
            "In case of suicide within 1 year of buying the policy, the claim won’t be admissible.",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "24px 0 0 24px",
          borderMobile: "18px 18px 0 0",
        },
        {
          title: "No maturity or survival benefit ",
          subTitle:
            "You will not get any money back, if you live beyond 75 years of age. Which is fine because by then all your dependents should be earning a livelihood and your savings would be enough to see you through any eventuality.  (Tip: Save the money you would have otherwise put into money back and ULIP policies.)",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 24px 24px 0",
          borderMobile: "0 0 18px 18px",
        },
      ],
    },

    health: {
      covered: [
        {
          title: "Hospitalisation for up to ₹5 Lakhs - INCLUDES COVID-19",
          subTitle:
            "You and your family get full coverage for your hospitalisation (for a minimum period of 24 consecutive hours) charges, daycare treatments (that may not require you to stay hospitalised for full 24 hours or more) and everything else during your treatment up to a limit of ₹5 Lakhs (for each family member). What does everything else include? Room charges, nursing expenses and intensive care unit charges, surgeon's fee, doctor's fee, anesthesia, blood, oxygen, operation theater charges, ICU charges and so on. For a complete list of 540+ day care procedures covered under our health insurance, see here. \n\nThe good news is that this hospitalisation coverage is applicable even in case of the policy holder testing positive for COVID-19. Keeping the current outbreak in mind, the plan gives you complete protection and financial security by covering everything from COVID-19 test (only in case of being tested positive) to hospitalisation to pre and post hospitalisation care.  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "24px 0 0 0",
          borderMobile: "18px 18px 0 0",
        },
        {
          title:
            "30 Days Pre-hospitalisation and 60 Days Post-hospitalisation - INCLUDES COVID 19 ",
          subTitle:
            "Not just the hospitalisation, but the pre and post care for the patient in question can be pretty taxing, emotionally as well as financially. Our health insurance goes a step ahead and covers your medical expenses, doctor consultations, diagnostic tests and routine medication charges up to 30 days before your hospitalisation and 60 days after.\n\nThis also includes reimbursement for pre and post hospitalisation charges in case the policy holder is tested positive for COVID-19. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 24px 0 0",
          borderMobile: "0 0 0 0",
        },
        {
          title: "Hospitalisation at Home ",
          subTitle:
            "In case of an emergency or a medical condition that does not allow you to get admitted in a hospital, you are covered for medical expenses incurred during your treatment at home for a period exceeding 3 consecutive days up to an amount of ₹50,000. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Cashless Facility in over 7400+ hospitals across India ",
          subTitle:
            "Enjoy a cashless facility on 7400+ hospitals across India (See list here) for your treatment. Please note that in case of hospitalisation due to COVID-19, this facility will not be available.  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Ambulance Coverage for up to ₹2000 ",
          subTitle:
            "You get reimbursed for expenses incurred by you while availing a domestic road ambulance during your hospitalization.  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Room Rent",
          subTitle:
            "You are eligible for a single private room during your hospitalization.",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Annual Health Check-up ",
          subTitle:
            "You get a free Annual Health Check-up for yourself and all family members covered by your policy, including children. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Get Back ₹5 lakhs Automatically ",
          subTitle:
            "In special cases where you run out of your health cover due to a claim made (Which must be ₹5 Lakhs or more), your cover of ₹5 Lakhs will be reinstated in your policy for you or your family members. Basically, think of this like recharging your talk time! So you and your family get fresh coverage for up to ₹5 Lakhs again, as long as you are not applying for the disease you’ve already claimed for.  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "No-Claim Bonus ",
          subTitle:
            "For every year that you don't claim, your sum insured increases by 10% overall, applicable up to a maximum of 50% in consecutive 5 years. So, hypothetically if you don’t file for a claim this year, your coverage for next year will be ₹5.5 Lakhs, ₹6 Lakhs the following year, up to a maximum of ₹7.5 Lakhs after 5 years. Isn’t that great? \n\nHowever, please note that once you claim, your coverage will drop back to ₹5 Lakhs for the next year. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Organ Donor Cover ",
          subTitle:
            "You will get reimburse for any medical expenses that are incurred by an organ donor while undergoing the organ transplant surgery up to ₹1 lakh.  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Free Second Opinion ",
          subTitle:
            "If you feel uncertain about your diagnosis, you can opt for a second opinion at no extra cost specially arranged by us from an expert.",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Lifelong Renewability  ",
          subTitle:
            "Once you buy this plan, you stay covered throughout your life, provided you renew the policy on time every year. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Alternate Treatments  ",
          subTitle:
            "Even treatments under Ayurveda, Unani, Sidha or Homeopathy are covered up to ₹20,000.  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Flexible Sum Insured ",
          subTitle:
            "You can increase or decrease your sum insured from ₹5 Lakhs every year at the time of renewal, depending your needs. For example, if it is recommended to increase your sum insured if you have a child or decrease it when your employer also provides you with health insurance. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
      ],
      notCovered: [
        {
          title: "30-day waiting period",
          subTitle:
            "There is a waiting period of 30 days before a claim can be filed for any illness except injury due to an accident. In other words, any diagnosis of disease / undergoing of surgery / occurrence of any event, whose signs or symptoms first occur within 30 days of after buying this olicy Period Start date. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 24px 0 0",
          borderMobile: "0 0 0 0",
        },
        {
          title: "4 Years of Waiting Period on Pre-existing Illnesses ",
          subTitle:
            "There is a waiting period for 4 years due to pre-existing illnesses like – diabetes, blood pressure, cancer, heart surgeries, etc. (Full List) ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "2 Years of Waiting Period for Special Ailments ",
          subTitle:
            "For certain diseases such as non-infective arthritis, joint replacement, cataract, etc, the coverage kicks in only after two years. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Self-Inflicted Injury from attempted Suicide ",
          subTitle:
            "Expenses attributable to self-inflicted injury (resulting from suicide, attempted suicide) are not covered. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Alcohol or Drug Use  ",
          subTitle:
            "Expenses arising out of or attributable to alcohol or drug use/misuse/abuse are not covered ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "AIDS ",
          subTitle:
            "Medical expenses incurred for treatment of AIDS are not covered ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Pregnancy-Related Expenses ",
          subTitle:
            "Treatment arising from or traceable to pregnancy and childbirth, miscarriage, abortion and its consequences are not covered ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Congenital disease ",
          subTitle:
            "Any ailment or diagnosis present from the time of birth is not covered under the health plan.  ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "OPD Expenses",
          subTitle:
            "Medical expenses for OPD and treatments where hospitalisation was not required are not covered.  ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Optical/dental care  ",
          subTitle:
            "Expenses for contact lenses, spectacles or a dental treatment are not covered   ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "In Vitro Fertilization ",
          subTitle:
            "Tests and treatment relating to infertility and in vitro fertilization are not covered. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "War, Riot, Strike and Nuclear Weapons  ",
          subTitle:
            "War, riot, strike, and nuclear weapons induced hospitalisation is not covered. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 18px 18px",
        },
      ],
    },
    home: {
      covered: [
        {
          title: "Theft upto ₹1.25 Lakhs",
          subTitle: "Theft in your home is covered up to ₹1.25 lakhs.",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "24px 0 0 0",
          borderMobile: "18px 18px 0 0",
        },
        {
          title: "Loss or Damage upto ₹1.25 Lakhs",
          subTitle:
            "Any kind of loss or damage on account of disasters like fire and others covered under STFI cover (Storm, Cyclone, Typhoon, Tempest, Hurricane, Tornado, Flood or Inundation) owing to loss/damage to your belongings is covered up to ₹1.25 Lakhs.  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 24px 0 0",
          borderMobile: "0 0 0 0",
        },
        {
          title: "Home Utility Appliances",
          subTitle:
            "Any accidental physical damage caused due to mechanical or electrical breakdown for utility items such as refrigerator, washing machine, air cooler, air conditioner, Microwave/oven is covered for up to ₹50,000 of repair expenses. There will be a standard annual depreciation applied to the claim amount. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 0 0",
        },
        {
          title: "Personal accident coverage up to ₹2 Lakhs ",
          subTitle:
            "In case of an injury or death due to an accident, you can an additional ₹2 Lakhs rupees  & additional hospitalisation coverage up to ₹20,000 beyond your what you will get in life and health insurance. ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Baggage coverage up to ₹5,000 ",
          subTitle:
            "Any kind of loss or damage of personal baggage is covered for up to ₹5,000  ",
          icon: require("../../../assets/images/landing/tick-green-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
      ],
      notCovered: [
        {
          title: "Structure of your Home ",
          subTitle:
            "This policy only covers your belongings inside your home, and not the building structure of your house. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "24px 0 0 0",
          borderMobile: "18px 18px 0 0",
        },
        {
          title: "Loss or damage of Mobile Phones and Electronic Gadgets ",
          subTitle:
            "Loss or damage to mobile phones and other home electronics such as TV, Computers, Music Systems, Gaming consoles, etc. are not covered. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 24px 0 0",
          borderMobile: "0 0 0 0",
        },
        {
          title: "Deductible on the theft/disaster coverage  ",
          subTitle:
            "There will be a deductible applicable of 5% on the claim for theft or damage on account of the covered disasters.  ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 0",
          borderMobile: "0 0 0 0",
        },
        {
          title: "Standard Depreciation Is Applicable",
          subTitle:
            "A 10% annual depreciation will be applied to all the claim amount submitted. So, if your appliance is 2 years old, 20% will be deducted from the claim amount of theft or repair. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 0",
          borderMobile: "0 0 0 0",
        },
        {
          title: "Wear and tear",
          subTitle:
            "Loss or damage caused by depreciation or wear and tear to any appliances or utility item is not covered under the plan ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 0 24px",
          borderMobile: "0 0 0 0",
        },
        {
          title: "Jewellery and Cash",
          subTitle:
            "The home insurance doesn’t cover any loss or damage to your Jewellery and cash. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Riots or Terrorism Damage Cover ",
          subTitle:
            "Any kind of loss or theft during any riot, strike or act of terrorism is not covered under the home insurance plan. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Bicycles or motor vehicles ",
          subTitle:
            "Theft or damage to any belonging under motor vehicles, or bicycles is not covered ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Belongings without invoice ",
          subTitle:
            "Original invoice of all the appliances will be needed at the time of the claim. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
        {
          title: "Standard Depreciation Is Applicable  ",
          subTitle:
            "A 10% annual depreciation will be applied to all the claim amount. So, if your appliance is 2 years old, 20% will be deducted from the claim amount of theft or repair. ",
          icon: require("../../../assets/images/landing/cross-red-thick.svg"),
          borderRadius: "0 0 24px 0",
          borderMobile: "0 0 18px 18px",
        },
      ],
    },
  };
  brochureLinks = {
    single:
      "https://toffee-cdn.s3.ap-south-1.amazonaws.com/documents/Single_Toffee_Plan.pdf",
    family:
      "https://toffee-cdn.s3.ap-south-1.amazonaws.com/documents/Family_Toffee_Plan.pdf",
  };

  getPrice(plan) {
    switch (plan) {
      case "single":
        return 880;
      case "family":
        return 1046;
      default:
        break;
    }
  }
  selectTab(tab) {
    this.setState({
      selectedSection: tab,
    });
    if (this.state.device === "web") {
      window.scrollTo(0, 223);
    } else {
      window.scrollTo(0, 198);
    }
  }
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web",
    });
    window.addEventListener("scroll", this.handleScroll);
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    // console.log("Removed");
  }

  handleScroll = (event) => {
    if (
      (this.state.device === "web" &&
        event.srcElement.scrollingElement.scrollTop > 223) ||
      (this.state.device === "mobile" &&
        event.srcElement.scrollingElement.scrollTop > 198)
    ) {
      this.setState({
        fullTabBar: true,
      });
    } else {
      this.setState({
        fullTabBar: false,
      });
    }
  };
  render() {
    return (
      <>
        <div className="product-page-container">
          <div className="m-0 p-0 details-row">
            <div className="left-section">
              <div className="logo-section">
                {this.state.selectedPlan === "single" && (
                  <img
                    className={"simple-logo"}
                    src={require("../../../assets/images/landing/single-plan-logo.png")}
                    alt=""
                  />
                )}
                {this.state.selectedPlan === "family" && (
                  <img
                    className={"smart-logo"}
                    src={require("../../../assets/images/landing/family-plan-logo.png")}
                    alt=""
                  />
                )}

                <div className={"name-rate"}>
                  <p className=" m-0 h3-red name text-capitalize">
                    {this.state.selectedPlan}
                  </p>
                  <span className="plan-text">Toffee Plan</span>
                  <p className={"rate m-0"}>
                    From ₹{this.getPrice(this.state.selectedPlan)}/ Month
                  </p>
                </div>
              </div>
            </div>
            <div className="right-section">
              <div className="button-container">
                <a href="tel:+919389938938">
                  <Button className={"download-btn"}>
                    <p>
                      <span className="font-weight-normal">Talk to an</span>
                      <br />
                      Insurance Expert
                    </p>
                    <img
                      src={require("../../../assets/images/icons/call-white.png")}
                      alt=""
                    />
                  </Button>
                </a>
              </div>
              <div className="button-container">
                <a
                  href={this.brochureLinks[this.state.selectedPlan]}
                  target="_blank"
                >
                  <Button className={"download-btn"}>
                    <p>Download Brochure</p>
                    <img
                      src={require("../../../assets/images/icons/download-white.png")}
                      alt=""
                    />
                  </Button>
                </a>
              </div>
            </div>
          </div>
          <div className="middle-card">
            <div
              className={this.state.fullTabBar ? "tab-bar forFull" : "tab-bar"}
            >
              <div
                className={
                  this.state.selectedSection === "life" ? "tab active" : "tab"
                }
                onClick={(e) => {
                  e.preventDefault();
                  this.selectTab("life");
                }}
              >
                Life
              </div>
              <div
                className={
                  this.state.selectedSection === "health" ? "tab active" : "tab"
                }
                onClick={(e) => {
                  e.preventDefault();
                  this.selectTab("health");
                }}
              >
                Health
              </div>
              <div
                className={
                  this.state.selectedSection === "home" ? "tab active" : "tab"
                }
                onClick={(e) => {
                  e.preventDefault();
                  this.selectTab("home");
                }}
              >
                Household
              </div>
              <div
                className={
                  this.state.selectedSection === "scenarios"
                    ? "tab claim-tab active "
                    : "tab claim-tab"
                }
                onClick={(e) => {
                  e.preventDefault();
                  this.selectTab("scenarios");
                }}
              >
                How to claim?
              </div>
            </div>
            {this.state.selectedSection === "life" && (
              <div className="covered-section">
                <h2 className="section-title">What's Covered</h2>
                <div className="d-flex combined-section">
                  <div className="m-0 p-0 card-row">
                    {this.state.selectedSection !== "scenarios" &&
                      this.cards[this.state.selectedSection].covered.map(
                        (item) => {
                          return (
                            <CoveredItem
                              title={item.title}
                              subTitle={item.subTitle}
                              icon={item.icon}
                            />
                          );
                        }
                      )}
                  </div>
                </div>
              </div>
            )}
            {this.state.selectedSection === "health" &&
              this.state.selectedPlan !== "simple" && (
                <div className="covered-section">
                  <h2 className="section-title">What's Covered</h2>
                  <div className="d-flex combined-section">
                    <div className="m-0 p-0 card-row">
                      {this.state.selectedSection !== "scenarios" &&
                        this.cards[this.state.selectedSection].covered.map(
                          (item) => {
                            return (
                              <CoveredItem
                                title={item.title}
                                subTitle={item.subTitle}
                                icon={item.icon}
                              />
                            );
                          }
                        )}
                    </div>
                  </div>
                </div>
              )}
            {this.state.selectedSection === "home" &&
              !["simple", "smart"].includes(this.state.selectedPlan) && (
                <div className="covered-section">
                  <h2 className="section-title">What's Covered</h2>
                  <div className="d-flex combined-section">
                    <div className="m-0 p-0 card-row">
                      {this.state.selectedSection !== "scenarios" &&
                        this.cards[this.state.selectedSection].covered.map(
                          (item) => {
                            return (
                              <CoveredItem
                                title={item.title}
                                subTitle={item.subTitle}
                                icon={item.icon}
                              />
                            );
                          }
                        )}
                    </div>
                  </div>
                </div>
              )}
            {this.state.selectedSection === "life" && (
              <div className="not-covered-section">
                <h2 className="section-title">What's Not Covered</h2>
                <div className="d-flex ">
                  <div className="m-0 p-0 card-row">
                    {this.state.selectedSection !== "scenarios" &&
                      this.cards[this.state.selectedSection].notCovered.map(
                        (item) => {
                          return (
                            <CoveredItem
                              title={item.title}
                              subTitle={item.subTitle}
                              icon={item.icon}
                            />
                          );
                        }
                      )}
                  </div>
                </div>
              </div>
            )}
            {this.state.selectedSection === "health" && (
              <div className="not-covered-section">
                {this.state.selectedSection !== "scenarios" &&
                  this.state.selectedPlan !== "simple" && (
                    <h2 className="section-title">What's Not Covered</h2>
                  )}
                <div className="d-flex ">
                  <div className="m-0 p-0 card-row">
                    {this.state.selectedSection !== "scenarios" &&
                    this.state.selectedPlan !== "simple" ? (
                      this.cards[this.state.selectedSection].notCovered.map(
                        (item) => {
                          return (
                            // <ImageText
                            //   title={item.title}
                            //   subTitle={item.subTitle}
                            //   icon={item.icon}
                            //   borderRadius={item.borderRadius}
                            //   borderMobile={item.borderMobile}
                            // />
                            <CoveredItem
                              title={item.title}
                              subTitle={item.subTitle}
                              icon={item.icon}
                            />
                          );
                        }
                      )
                    ) : (
                      <NotCoveredItem
                        plan={this.state.selectedPlan}
                        section={this.state.selectedSection}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {this.state.selectedSection === "home" && (
              <div className="not-covered-section">
                {this.state.selectedSection !== "scenarios" &&
                  !["simple", "smart"].includes(this.state.selectedPlan) && (
                    <h2 className="section-title">What's Not Covered</h2>
                  )}
                <div className="d-flex ">
                  <div className="m-0 p-0 card-row">
                    {this.state.selectedSection !== "scenarios" &&
                    !["simple", "smart"].includes(this.state.selectedPlan) ? (
                      this.cards[this.state.selectedSection].notCovered.map(
                        (item) => {
                          return (
                            <CoveredItem
                              title={item.title}
                              subTitle={item.subTitle}
                              icon={item.icon}
                            />
                          );
                        }
                      )
                    ) : (
                      <NotCoveredItem
                        plan={this.state.selectedPlan}
                        section={this.state.selectedSection}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
            {this.state.selectedSection === "scenarios" && (
              <>
                <div className="covered-section">
                  <div className="d-flex w-100">
                    <HowToClaim />
                  </div>
                </div>
                <div className="covered-section">
                  <h2 className="section-title life-example-title">
                    Real Life Examples
                  </h2>
                  <div className="d-flex ">
                    <LifeExamples />
                  </div>
                </div>
              </>
            )}
          </div>

          <div className={"buy-ribbon "}>
            <div className="left-section">
              {this.state.selectedPlan === "single" && (
                <img
                  src={require("../../../assets/images/landing/single-plan-logo.png")}
                  alt=""
                />
              )}
              {this.state.selectedPlan === "family" && (
                <img
                  src={require("../../../assets/images/landing/family-plan-logo.png")}
                  alt=""
                />
              )}
              <p className=" d-inline text-capitalize">
                {this.state.selectedPlan} Toffee Plan
              </p>
            </div>
            <div className="right-section">
              <h3 className="premium-line">
                From{" "}
                <span className="font-weight-bold">
                  ₹{this.getPrice(this.state.selectedPlan)}/Month
                </span>
              </h3>
              <div className={"btn-container"}>
                <InnerShadowButton
                  clicked={(e) => {
                    this.props.history.push(
                      "/product/" + this.state.selectedPlan + "/calculate"
                    );
                    // window.location = this.state.calculatePremiumLink;
                  }}
                  title="Calculate Premium"
                  active={true}
                />
              </div>
            </div>
          </div>
        </div>
        {/* <Footer /> */}
      </>
    );
  }
}
export default ProductNewDesign;
